if (!customElements.get("klaviyo-forms")) {
  class KlaviyoForms extends HTMLElement {
    constructor() {
      super();
      window.addEventListener("klaviyoForms", function (e) {
        if (e.detail.type != "submit") return;

        const submittedForm = e.detail.formId;
        document
          .querySelector(`[data-form-wrapper='${submittedForm}']`)
          .classList.add("submitted");
      });

      const klaviyoFormButtons = this.querySelectorAll(".klaviyo-form__button");
      klaviyoFormButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
          e.preventDefault();

          const formId = button.getAttribute("form-id");
          const klaviyoForm = document.querySelector(`.${formId}`);
          klaviyoForm.classList.remove("hidden");
          button.classList.add("hidden");
        });
      });
    }
  }

  customElements.define("klaviyo-forms", KlaviyoForms);
}
